// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2olcy","label":"Labeled_label__2Kdl4","divider":"Labeled_divider__16t4c"};